import Button from '@berlitz/button'
import Checkbox from '@berlitz/checkbox'
import { Clear } from '@berlitz/icons'
import { CloseButton, ConfirmText } from '@layouts/LearningPath/Chapter/style'
import React from 'react'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import { Confirmation as ConfirmationComp } from './style'

interface Props {
  setShowConfirmation: (arg: boolean) => void
  showConfirmation: boolean
}

const Confirmation: React.FC<Props & InjectedIntlProps> = ({ setShowConfirmation, showConfirmation, intl }) => {
  const [confirmation, setConfirmation] = React.useState(false)
  if (!showConfirmation) {
    return null
  }

  return (
    <ConfirmationComp>
      <div className="display-flex">
        <CloseButton onClick={() => setShowConfirmation(!showConfirmation)}>
          <Clear color="brand03" size="sm" />{' '}
        </CloseButton>
      </div>
      <div className="text-container">
        <ConfirmText>
          <FormattedMessage id="Redo online practice" />?
        </ConfirmText>
        <div className="subtext">
          <FormattedMessage id="Don't worry your highest score will be kept" />
        </div>
        <div className="btn-container">
          <Button fullWidth>
            <FormattedMessage id="Redo online practice" />
          </Button>
        </div>

        <div className="checkbox-container">
          <Checkbox
            checked={confirmation}
            label={intl.formatMessage({
              id: `Don't show this again`,
            })}
            name="show"
            value={`show`}
            onChange={() => setConfirmation(!confirmation)}
          />
        </div>
      </div>
    </ConfirmationComp>
  )
}

export default injectIntl(Confirmation)
